import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  UserPlus, FileText, Calendar, 
  TestTube, BarChart3
} from 'lucide-react';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { icon: UserPlus, label: 'مريض جديد', color: 'blue', path: '/customers/new' },
    { icon: TestTube, label: 'فحص جديد', color: 'green', path: '/tests' },
    { icon: Calendar, label: 'حجز موعد', color: 'purple', path: '/bookings/new' },
    { icon: BarChart3, label: 'التقارير', color: 'orange', path: '/reports/sales' },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">الإجراءات السريعة</h3>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action, index) => {
          const Icon = action.icon;
          const colorClasses = {
            blue: 'hover:bg-blue-50 hover:border-blue-300 text-blue-600',
            green: 'hover:bg-green-50 hover:border-green-300 text-green-600',
            purple: 'hover:bg-purple-50 hover:border-purple-300 text-purple-600',
            orange: 'hover:bg-orange-50 hover:border-orange-300 text-orange-600',
          };
          
          return (
            <motion.button
              key={index}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate(action.path)}
              className={`flex items-center gap-3 p-3 rounded-lg border border-gray-200 transition-all ${colorClasses[action.color]}`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm font-medium">{action.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
